// Start this when all javascript is loaded
import lunr from 'lunr';
import stemmerSupport from 'lunr-languages/lunr.stemmer.support.js';
import multi from 'lunr-languages/lunr.multi.js';
import nl from 'lunr-languages/lunr.nl.js';

// Initialize language support
stemmerSupport(lunr);
multi(lunr);
nl(lunr);

async function loadIndex(path) {
  const response = await fetch(path);
  const data = await response.json();
  // Initialize language support before loading the index
  if (lunr?.multiLanguage) {
    lunr.multiLanguage('en', 'nl');
  }

  const contentIdx = lunr.Index.load(data.contentIdx);
  const publicationsIdx = lunr.Index.load(data.publicationsIdx);
  return { contentIdx, publicationsIdx, documents: data.documents };
}

async function getResults(query, searchPublication) {
  const { contentIdx, publicationsIdx, documents } = await loadIndex('scripts/searchIndex.json');
  const resultsContainer = document.getElementById('results');
  resultsContainer.innerHTML = '';

  const idx = searchPublication ? publicationsIdx : contentIdx;
  const results = idx.search(query);

  resultsContainer.innerHTML = `
      <div class="no-results">
        <h1>${results.length || 'Geen'} ${searchPublication ? 'publicaties' : 'artikelen'} gevonden met '${query}'</h1>
      </div>
    `;

  if (results.length === 0) {
    return;
  }

  const ul = document.createElement('ul');
  ul.classList.add('results');
  resultsContainer.appendChild(ul);
  for (const result of results) {
    const ref = result.ref;
    const doc = documents[ref];
    const { path, title } = doc || {};
    const li = document.createElement('li');
    li.innerHTML = `<a href="${path}">${title}</a>`;
    ul.appendChild(li);
  }
}

window.addEventListener('load', function () {
  const search = URLSearchParams ? new URLSearchParams(globalThis.location.search) : null;
  if (!search?.has('s')) {
    return;
  }
  getResults(search.get('s'), search.get('search_type') === 'publication');
});
